/**
 * 手机端手写签名页（免登录）
 * 不挂载 Main 布局，独立全屏页面，meta.auth = false
 */
const mobileSignRouter = {
  path: '/mobile/sign',
  name: 'mobileSign',
  component: resolve => require(['@pages/mobileSign/pages/mobileSign'], resolve),
  meta: {
    title: '手写签名',
    auth: false
  }
}

export default mobileSignRouter



// WEBPACK FOOTER //
// ./src/pages/mobileSign/index.js